import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/device/local/data.service';

@Component({
  selector: 'app-console-view',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  templateUrl: './console-view.page.html',
  styleUrls: ['./console-view.page.scss']
})
export class ConsoleViewPage implements OnInit {
  private localData = inject(DataService);
  private modalCtrl = inject(ModalController);

  logs = [];
  expandedItems = new Set<string>();

  ngOnInit() {
    this.logs = this.localData.capturedLogs;
  }

  close() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  clearLogs() {
    this.localData.clearLog();
    this.logs = [];
    this.expandedItems.clear();
  }

  isExpandable(arg: any): boolean {
    return arg.type === 'object' || arg.type === 'array';
  }

  toggleExpand(logIndex: number, argIndex: number) {
    const key = `${logIndex}-${argIndex}`;
    if (this.expandedItems.has(key)) {
      this.expandedItems.delete(key);
    } else {
      this.expandedItems.add(key);
    }
  }

  isExpanded(logIndex: number, argIndex: number): boolean {
    return this.expandedItems.has(`${logIndex}-${argIndex}`);
  }

  formatJson(value: any): string {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }

  getTypeClass(type: string): string {
    switch (type) {
      case 'LOG':
        return 'log-type-log';
      case 'WARN':
        return 'log-type-warn';
      case 'ERROR':
        return 'log-type-error';
      default:
        return '';
    }
  }

  trackByIndex(index: number): number {
    return index;
  }
}
